/** @format */

import React from 'react';
import TemplateButton from './TemplateButton.js';
import PropTypes from 'prop-types';
import { ReactComponent as Cancel } from '../../assets/themes/OPL/img/icons/Cancel.svg';

function CancelButton({ ...props }) {
    const { classes, callback, callbackParam, color, text, ...rest } = props;
    return (
        <TemplateButton
            {...rest}
            className={classes}
            classes={classes}
            icon={Cancel}
            color={color}
            callback={callback}
            callbackParam={callbackParam}
            text={text}
        />
    );
}

CancelButton.propTypes = {
    callback: PropTypes.func.isRequired,
    callbackParam: PropTypes.object.isRequired,
    color: PropTypes.string,
    text: PropTypes.string,
};

export default CancelButton;
